/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GoogleProtobufDurationFromJSON, GoogleProtobufDurationToJSON, StreemApiCallDetailFromJSON, StreemApiCallDetailToJSON, StreemApiGroupFromJSON, StreemApiGroupToJSON, StreemApiRoomDetailFromJSON, StreemApiRoomDetailToJSON, StreemApiRoomInvitationFromJSON, StreemApiRoomInvitationToJSON, StreemApiRoomParticipantFromJSON, StreemApiRoomParticipantToJSON, } from './';
export function StreemApiRoomFromJSON(json) {
    return StreemApiRoomFromJSONTyped(json, false);
}
export function StreemApiRoomFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sid': !exists(json, 'sid') ? undefined : json['sid'],
        'createdByUserSid': !exists(json, 'created_by_user_sid') ? undefined : json['created_by_user_sid'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'openedAt': !exists(json, 'opened_at') ? undefined : (new Date(json['opened_at'])),
        'preferredVideoCodec': !exists(json, 'preferred_video_codec') ? undefined : json['preferred_video_codec'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'closedAt': !exists(json, 'closed_at') ? undefined : (new Date(json['closed_at'])),
        'twilioRoomSid': !exists(json, 'twilio_room_sid') ? undefined : json['twilio_room_sid'],
        'referenceId': !exists(json, 'reference_id') ? undefined : json['reference_id'],
        'participants': !exists(json, 'participants') ? undefined : (json['participants'].map(StreemApiRoomParticipantFromJSON)),
        'companySid': !exists(json, 'company_sid') ? undefined : json['company_sid'],
        'videoPlatform': !exists(json, 'video_platform') ? undefined : json['video_platform'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
        'wallPlatform': !exists(json, 'wall_platform') ? undefined : json['wall_platform'],
        'integrationId': !exists(json, 'integration_id') ? undefined : json['integration_id'],
        'details': !exists(json, 'details') ? undefined : (json['details'].map(StreemApiRoomDetailFromJSON)),
        'reservationSid': !exists(json, 'reservation_sid') ? undefined : json['reservation_sid'],
        'roomInvitations': !exists(json, 'room_invitations') ? undefined : (json['room_invitations'].map(StreemApiRoomInvitationFromJSON)),
        'chimeRoomSid': !exists(json, 'chime_room_sid') ? undefined : json['chime_room_sid'],
        'recordingStartedAt': !exists(json, 'recording_started_at') ? undefined : (new Date(json['recording_started_at'])),
        'callDuration': !exists(json, 'call_duration') ? undefined : GoogleProtobufDurationFromJSON(json['call_duration']),
        'callDetail': !exists(json, 'call_detail') ? undefined : StreemApiCallDetailFromJSON(json['call_detail']),
        'reservationGroup': !exists(json, 'reservation_group') ? undefined : StreemApiGroupFromJSON(json['reservation_group']),
    };
}
export function StreemApiRoomToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sid': value.sid,
        'created_by_user_sid': value.createdByUserSid,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'opened_at': value.openedAt === undefined ? undefined : (value.openedAt.toISOString()),
        'preferred_video_codec': value.preferredVideoCodec,
        'status': value.status,
        'closed_at': value.closedAt === undefined ? undefined : (value.closedAt.toISOString()),
        'twilio_room_sid': value.twilioRoomSid,
        'reference_id': value.referenceId,
        'participants': value.participants === undefined ? undefined : (value.participants.map(StreemApiRoomParticipantToJSON)),
        'company_sid': value.companySid,
        'video_platform': value.videoPlatform,
        'deleted': value.deleted,
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'wall_platform': value.wallPlatform,
        'integration_id': value.integrationId,
        'details': value.details === undefined ? undefined : (value.details.map(StreemApiRoomDetailToJSON)),
        'reservation_sid': value.reservationSid,
        'room_invitations': value.roomInvitations === undefined ? undefined : (value.roomInvitations.map(StreemApiRoomInvitationToJSON)),
        'chime_room_sid': value.chimeRoomSid,
        'recording_started_at': value.recordingStartedAt === undefined ? undefined : (value.recordingStartedAt.toISOString()),
        'call_duration': GoogleProtobufDurationToJSON(value.callDuration),
        'call_detail': StreemApiCallDetailToJSON(value.callDetail),
        'reservation_group': StreemApiGroupToJSON(value.reservationGroup),
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiRoomPreferredVideoCodec;
(function (StreemApiRoomPreferredVideoCodec) {
    StreemApiRoomPreferredVideoCodec["H264"] = "VIDEO_CODEC_H264";
    StreemApiRoomPreferredVideoCodec["INVALID"] = "VIDEO_CODEC_INVALID";
    StreemApiRoomPreferredVideoCodec["VP8"] = "VIDEO_CODEC_VP8";
    StreemApiRoomPreferredVideoCodec["VP9"] = "VIDEO_CODEC_VP9";
})(StreemApiRoomPreferredVideoCodec || (StreemApiRoomPreferredVideoCodec = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiRoomStatus;
(function (StreemApiRoomStatus) {
    StreemApiRoomStatus["CLOSED"] = "STATUS_CLOSED";
    StreemApiRoomStatus["INVALID"] = "STATUS_INVALID";
    StreemApiRoomStatus["OPEN"] = "STATUS_OPEN";
})(StreemApiRoomStatus || (StreemApiRoomStatus = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiRoomVideoPlatform;
(function (StreemApiRoomVideoPlatform) {
    StreemApiRoomVideoPlatform["ARAAS"] = "VIDEO_PLATFORM_ARAAS";
    StreemApiRoomVideoPlatform["CHIME"] = "VIDEO_PLATFORM_CHIME";
    StreemApiRoomVideoPlatform["INVALID"] = "VIDEO_PLATFORM_INVALID";
    StreemApiRoomVideoPlatform["TWILIO"] = "VIDEO_PLATFORM_TWILIO";
})(StreemApiRoomVideoPlatform || (StreemApiRoomVideoPlatform = {}));
/**
* @export
* @enum {string}
*/
export var StreemApiRoomWallPlatform;
(function (StreemApiRoomWallPlatform) {
    StreemApiRoomWallPlatform["STREEM"] = "WALL_PLATFORM_STREEM";
    StreemApiRoomWallPlatform["TWILIO"] = "WALL_PLATFORM_TWILIO";
    StreemApiRoomWallPlatform["INVALID"] = "WALL_PLATFORM_INVALID";
})(StreemApiRoomWallPlatform || (StreemApiRoomWallPlatform = {}));
//# sourceMappingURL=StreemApiRoom.js.map